import { Link, Route, Routes, useLocation } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import { FiBriefcase } from "react-icons/fi";
import { FiCode } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { FiGithub } from "react-icons/fi";
import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Experience from "./pages/Experience.js";
import Portfolio from "./pages/Portfolio.js";
import { useEffect, useState } from "react";
import pf from './img/pf.png';

function App() {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [hidenPhoto, setHidenPhoto] = useState(false);
  const width = window.innerWidth;
  const activePage = (path) =>{
    return(splitLocation[2] === path ? "active" : "");
  }
  const hidePhoto = () => {
    if(width <= 768){
     
      if(activePage('') === 'active'){
        setHidenPhoto(false)
      }else{
        setHidenPhoto(true)
      }
    }else{
      setHidenPhoto(false)
    }
  };
  useEffect(() => {
    hidePhoto();
  })
  return (
    <>
      <header>
        <nav className="nav-menu">
          <ul>
            <li className={activePage('')}><Link to='/my_cv/' onClick={()=>hidePhoto()}><FiHome/></Link></li>
            <li className={activePage('about')}><Link to='/my_cv/about' onClick={()=>hidePhoto()}><FiUser /></Link></li>
            <li className={activePage('experience')}><Link to='/my_cv/experience' onClick={()=>hidePhoto()}><FiBriefcase /></Link></li>
            <li className={activePage('portfolio')}><Link to='/my_cv/portfolio' onClick={()=>hidePhoto()}><FiCode /></Link></li>
            <li className={activePage('contact')}><a href='https://wa.me/6281234567890' target="_blank" rel="noreferrer"><FiPhone /></a></li>
            <li className={activePage('github')}><a href='https://github.com/choyrul12' target="_blank" rel="noreferrer"><FiGithub /></a></li>
          </ul>
        </nav>
      </header>
      <div className="container">
        <Routes>
          <Route path="/my_cv/" element={<Home/>} />
          <Route path="/my_cv/about" element={<About/>} />
          <Route path="/my_cv/experience" element={<Experience/>} />
          <Route path="/my_cv/portfolio" element={<Portfolio/>} />
        </Routes>
        <div className="photo">
          {hidenPhoto ? '' : <img src={pf} alt="" />}
        </div>
      </div>
    </>
  );
}

export default App;
